<section class="chart-editor-page-layout chart-environment-full-layout">
  <hd-chart-shortcut-bar
      [mobile]="viewport.isPhone()"
      (ringCycleRequested)="cycleMandalaRing()"
      (moreRequested)="handleMobileMoreRequested($event)"
      [primaryGateAction]="chartGatePrimaryAction()"
      [isFrozen]="hoverSnapshotFrozen()"
      [gameActive]="gameActive()"
      [gameMode]="gameMode()"
      [showPlanetGrid]="effectiveShowPlanetGrid()"
      [simplePlanetGrid]="effectiveSimplePlanetGrid()"
      [advancedLpsGrid]="advancedLpsGrid()"
      [planetGridVisualizationMode]="planetGridVisualizationMode()"
      [includeNonHdFeatures]="includeNonHdFeatures()"
      [showGeneKeys]="showGeneKeys()"
      [showHdKeynotes]="showHdKeynotes()"
      [showCenterCheatSheet]="showCenterCheatSheet()"
      [showGateBlocks]="showGateBlocks()"
      [moveToolActive]="moveToolActive()"
      [hasPlanetaryActivations]="hasPlanetaryActivations()"
      [annotationActive]="annotationStore.active()"
      [viewMode]="effectiveViewMode()"
      [sideMode]="chartSideMode()"
      [tripleViewActive]="tripleChartView()"
      [moonTransitActive]="moonTransitMode()"
      [moonTransitAvailable]="moonTransitAvailable()"
      [justNowTransitActive]="justNowTransitVisualsActive()"
      [justNowTransitAvailable]="justNowTransitAvailable()"
      [justNowTransitLoading]="justNowTransitLoading()"
      [justNowTransitStatusTooltip]="justNowTransitStatusTooltip()"
      [locksKeysActive]="locksKeysMode()"
      [locksKeysAvailable]="locksKeysAvailable()"
      [cycleChartActive]="activeCycleInfo() != null"
      [compositeChartActive]="activeCompositeInfo() != null"
      [dockAllAvailable]="dockAllPanelsAvailable()"
      [undockAllAvailable]="undockAllPanelsAvailable()"
      [closeAllAvailable]="closeAllPanelsAvailable()"
      [transitsActive]="transitsPanelOpen()"
      [buttonSize]="shortcutButtonSize()"
      [showZodiacRing]="showMandalaZodiacRing()"
      [showQuarterRing]="showMandalaQuarterRing()"
      [showIchingRing]="showMandalaIchingRing()"
      [showGodheadRing]="showMandalaGodheadRing()"
      [showSideStats]="effectiveShowPlanetSideStats()"
      [sideStatsFitAdvancedLps]="sideStatsFitBesideResonance()"
      [canSaveChart]="canSaveActiveChart()"
      [canShareChart]="canShareActiveChart()"
      (newChartRequested)="handleNewChartRequested()"
      (saveChartRequested)="saveActiveChart()"
      (shareChartRequested)="handleShareChartRequested()"
      (chartManagerRequested)="handleChartManagerRequested()"
      (gameRequested)="handleGameRequested()"
      (viewModeChange)="handleViewModeChange($event)"
      (sideModeChange)="handleChartSideModeChange($event)"
      (tripleViewToggled)="handleTripleViewToggled()"
      (moonTransitToggled)="toggleMoonTransitMode()"
      (justNowTransitToggled)="toggleJustNowTransitMode()"
      (locksKeysToggled)="toggleLocksKeysMode()"
      (transitsToggled)="handleTransitsToggled()"
      (zodiacRingToggled)="toggleMandalaZodiacRing()"
      (quarterRingToggled)="toggleMandalaQuarterRing()"
      (ichingRingToggled)="toggleMandalaIchingRing()"
      (godheadRingToggled)="toggleMandalaGodheadRing()"
      (sideStatsToggled)="togglePlanetSideStats()"
      (annotateToggled)="handleAnnotateToggled()"
      (clearAnnotationsRequested)="annotationStore.clear()"
      (justNowRequested)="handleJustNowRequested({ personalityOnly: true })"
      (resetRequested)="handleShortcutResetRequested()"
      (primaryGateActionChange)="handlePrimaryGateActionChange($event)"
      (dockAllPanelsRequested)="handleDockAllPanelsRequested()"
      (undockAllPanelsRequested)="handleUndockAllPanelsRequested()"
      (closeAllPanelsRequested)="handleCloseAllPanelsRequested()"
      (planetGridToggled)="togglePlanetGrid()"
      (simplePlanetGridToggled)="toggleSimplePlanetGrid()"
      (advancedLpsGridToggled)="toggleAdvancedLpsGrid()"
      (visualizationModeToggled)="toggleVisualizationMode()"
      (geneKeysToggled)="toggleGeneKeys()"
      (hdKeynotesToggled)="toggleHdKeynotes()"
      (centerCheatSheetToggled)="toggleCenterCheatSheet()"
      (gateBlocksToggled)="toggleShowGateBlocks()"
      (moveToolToggled)="handleMoveToolToggled()"
      (moveToolContextMenuRequested)="handleMoveToolContextMenu($event)"
      (unfreezeRequested)="handleUnfreezeRequested()"
      (stopRequested)="handleShortcutStopRequested()"
  ></hd-chart-shortcut-bar>

  <div
    class="chart-content-row"
    [class.config-collapsed]="configPanelCollapsed()"
    [style.--config-panel-width.px]="configPanelWidth()"
  >
    <div class="main-content">
      <hd-chart-tab-bar
      [tabs]="tabBarItems()"
      [activeTabId]="tabsService.activeTabId()"
      (tabSelected)="handleTabSelected($event)"
      (tabCloseRequested)="handleTabCloseRequested($event)"
      (addRequested)="handleAddTabRequested()"
      (tabReordered)="handleTabReordered($event)"
      (closeAllTabsRequested)="handleCloseAllTabsRequested()"
      (closeTabsToLeftRequested)="handleCloseTabsToLeftRequested($event)"
      (closeTabsToRightRequested)="handleCloseTabsToRightRequested($event)"
      (reloadRequested)="handleReloadRequested($event)"
      (recalculateRequested)="handleRecalculateRequested($event)"
      (saveChartRequested)="handleTabSaveRequested($event)"
      (renameRequested)="handleTabRenameRequested($event)"
      [momentSaveTabId]="momentSaveTabId()"
      (momentSaveRequested)="handleTabMomentSaveRequested($event)"
      (pdfDownloadRequested)="handleTabPdfDownloadRequested($event)"
    ></hd-chart-tab-bar>

    <!-- Gedeelde chart (spec 2026-10-20-chart-share §4.6): niet in de eigen library; opslaan maakt er een gewone tab van. -->
    @if (isSharedTab()) {
      <hd-shared-chart-banner
        mode="member"
        [chartName]="activePreset()?.name ?? ''"
        [sharedByName]="activeSharedByName()"
        [saveAvailable]="sharedTabSaveable()"
        (saveRequested)="saveActiveChart()"
      ></hd-shared-chart-banner>
    }

    <!-- Tijdslider (spec momenten stap 4): op een range-tab en bij een actieve
         just-now-overlay; net boven de chart, zoals gevraagd. -->
    @if (timeSliderState(); as sliderState) {
      <hd-transit-time-slider
        [startUtc]="sliderState.startUtc"
        [endUtc]="sliderState.endUtc"
        [valueUtc]="timeSliderValue()!"
        [mode]="sliderState.mode"
        [atAnchor]="timeSliderAtAnchor()"
        [busy]="transitSampleLoading()"
        (valueUtcChange)="handleTimeSliderValueChange($event)"
        (valueUtcCommitted)="handleTimeSliderValueCommitted($event)"
        (anchorRequested)="handleTimeSliderAnchorRequested()"
      ></hd-transit-time-slider>
    }

    <div
      #chartStackHost
      class="chart-stack"
      [class.chart-load-error]="chartLoadError()"
      [class.mandala-space-hidden]="mandalaHiddenForSpace()"
    >
      @if (!chartLoadError()) {
      @if (activeGameKind() === 'gate-guessing') {
        <div class="design-side-container game-panel-container">
          <hd-gate-guessing-game-panel
            (restartRequested)="handleGamePanelRestartRequested()"
          ></hd-gate-guessing-game-panel>
        </div>
      } @else if (activeGameKind() === 'channel-guessing') {
        <div class="design-side-container game-panel-container">
          <hd-channel-guessing-game-panel
            (restartRequested)="handleGamePanelRestartRequested()"
          ></hd-channel-guessing-game-panel>
        </div>
      } @else if (activeGameKind() === 'draw-chart') {
        <div class="design-side-container game-panel-container">
          <hd-draw-chart-game-panel
            (restartRequested)="handleGamePanelRestartRequested()"
          ></hd-draw-chart-game-panel>
        </div>
      } @else if (effectiveShowPlanetGrid() && (hasPlanetaryActivations() || justNowTransitVisualsActive())) {
        <div class="design-side-container" #mandalaLeftOverlay>
          @if (activeCycleInfo() || activeCompositeInfo()) {
            <!-- Cycle/composite chart: top-level D+P gecombineerd, met fixing
                 t.o.v. de tweede kant; composite toont de chartnaam erboven. -->
            <hd-just-now-base-planet-grid
              class="design-planet-grid"
              [activations]="allPlanetaryActivations()"
              [transitActivations]="cycleMomentGridActivations()"
              [sideMode]="'full'"
              [lineData]="justNowTransitLineData"
              [planetName]="justNowTransitPlanetName"
              [labels]="justNowBasePlanetGridLabels()"
              [chartLabel]="compositeChart1Label()"
              [designChiron]="showChiron() ? designChiron() : null"
              [personalityChiron]="showChiron() ? personalityChiron() : null"
              [contextMenuEnabled]="chartContextMenuEnabled()"
              (planetActivationClicked)="handlePlanetActivationClicked($event)"
              (planetBlockContextMenuRequested)="handlePlanetBlockContextMenuRequested($event)"
            />
          } @else if (justNowTransitVisualsActive()) {
            <hd-just-now-base-planet-grid
              class="design-planet-grid"
              [activations]="allPlanetaryActivations()"
              [transitActivations]="justNowTransitActivations()"
              [designChiron]="showChiron() ? designChiron() : null"
              [personalityChiron]="showChiron() ? personalityChiron() : null"
              [sideMode]="chartSideMode()"
              [lineData]="justNowTransitLineData"
              [planetName]="justNowTransitPlanetName"
              [labels]="justNowBasePlanetGridLabels()"
              [contextMenuEnabled]="chartContextMenuEnabled()"
              (planetActivationClicked)="handlePlanetActivationClicked($event)"
              (planetBlockContextMenuRequested)="handlePlanetBlockContextMenuRequested($event)"
            />
          } @else if (effectiveSimplePlanetGrid()) {
            <hd-simple-planet-grid
              class="design-planet-grid"
              [activations]="designActivations()"
              side="design"
              [showGrid]="effectiveSideMode() !== 'personality'"
              [chiron]="showChiron() ? designChiron() : null"
              [showHdKeynotes]="showHdKeynotes()"
              [contextMenuEnabled]="chartContextMenuEnabled()"
              [colorConfig]="planetGridColorConfig()"
              [showTransformationArrows]="effectivePlanetGridDensity() === 'normal'"
              (phsBlockClicked)="handlePhsBlockClicked($event)"
              (chironClicked)="handleChironClicked($event)"
              (planetActivationClicked)="handlePlanetActivationClicked($event)"
              (planetBlockContextMenuRequested)="handlePlanetBlockContextMenuRequested($event)"
            ></hd-simple-planet-grid>
          } @else {
            <hd-planet-grid
              class="design-planet-grid"
              [activations]="designActivations()"
              side="design"
              [density]="effectivePlanetGridDensity()"
              [renderState]="displayRenderState()"
              [colorConfig]="planetGridColorConfig()"
              [resonanceMode]="effectiveAdvancedLpsGrid()"
              [visualizationMode]="planetGridVisualizationMode()"
              [showGeneKeys]="showGeneKeys()"
              [showHdKeynotes]="showHdKeynotes()"
              [showSideStats]="effectiveShowPlanetSideStats()"
              [showGrid]="effectiveSideMode() !== 'personality'"
              [oppositeActivations]="personalityActivations()"
              [allActivations]="allPlanetaryActivations()"
              [statsSide]="effectiveSideMode() === 'full' ? null : effectiveSideMode()"
              [statsOverallRenderState]="renderState()"
              [contextMenuEnabled]="chartContextMenuEnabled()"
              [chironDesign]="showChiron() && !showAstroPositions() ? designChiron() : null"
              [chironPersonality]="showChiron() && !showAstroPositions() ? personalityChiron() : null"
              (chironClicked)="handleChironClicked($event)"
              [astroPoints]="showAstroPositions() ? designAstroPoints() : []"
              [astroChiron]="showAstroPositions() && showChiron() ? designChironPosition() : null"
              (astroPointClicked)="handleAstroPointClicked($event)"
              (planetActivationClicked)="handlePlanetActivationClicked($event)"
              (phsBlockClicked)="handlePhsBlockClicked($event)"
              (planetBlockContextMenuRequested)="handlePlanetBlockContextMenuRequested($event)"
            ></hd-planet-grid>
          }
        </div>
      }
      }

      <e-card2 class="chart-panel" [class.chart-panel--with-mandala]="effectiveViewMode() !== 'chart' || tripleChartView()" padding="4">
        <div
          #chartMandalaStack
          class="chart-mandala-stack"
          [attr.data-view-mode]="tripleChartView() || locksKeysCompareActive() ? null : effectiveViewMode()"
          [attr.data-triple-view]="tripleChartView() ? '' : null"
          [attr.data-moon-transit]="moonTransitMode() ? '' : null"
          [attr.data-just-now-transit]="justNowTransitVisualsActive() ? '' : null"
          [attr.data-locks-keys-compare]="locksKeysCompareActive() ? '' : null"
          [style.--mandala-chart-scale]="mandalaChartScale()"
          [style.--mandala-max-width]="mandalaMaxWidthPx()"
          [style.--triple-side-pull]="tripleSidePullPx()"
        >
          @if (tripleChartView()) {
            <!-- Drieluik (spec 2026-07-31): design | volledig | personality.
                 Op een cycle-/composite-tab (feedback 2026-08-23): bron 1 |
                 combinatie (mét twee-kleurenoverlay) | bron 2 — de zijcharts
                 zijn dan de volledige charts van persoon/chart 1 en
                 cyclus/chart 2. Zijcharts zijn read-only (show-info) — een
                 edit op een gefilterde of vreemde configuratie mag nooit in
                 de top-level chart belanden; het middenchart bewerkt de
                 volledige configuratie en de zijcharts volgen als computeds
                 vanzelf. Geen gate-block-layer of cheat-sheet in deze modus
                 (v1, spec §3.2). -->
            @let tripleLeft = tripleLeftChart();
            @let tripleRight = tripleRightChart();
            <div class="triple-chart-host triple-chart-host--design">
              <h3
                [class]="'triple-chart-label triple-chart-label--' + tripleLeft.labelKind"
                data-test-id="triple-chart-label-left"
              >{{ tripleLeft.label }}</h3>
              <hd-bodygraph-chart
                #tripleLeftChartHost
                class="triple-chart"
                [configuration]="tripleLeft.configuration"
                [locksKeysOverlay]="locksKeysChartOverlay()"
                [colorConfig]="colorConfig()"
                [interactionMode]="chartInteractionMode()"
                primaryGateAction="show-info"
                [contextMenuEnabled]="chartContextMenuEnabled()"
                [channelHighlightEnabled]="channelHighlightEnabled()"
                [showHdKeynotes]="showHdKeynotes()"
                (gateClicked)="handleGateClicked($event)"
                (gateInfoRequested)="handleGateInfoRequested($event)"
                (channelInfoRequested)="handleChannelInfoRequested($event)"
                (centerInfoRequested)="handleCenterInfoRequested($event)"
                (gateContextMenuRequested)="handleGateContextMenuRequested($event)"
                (centerContextMenuRequested)="handleCenterContextMenuRequested($event)"
              ></hd-bodygraph-chart>
            </div>

            <div class="triple-chart-host triple-chart-host--full">
              <hd-bodygraph-chart
                class="triple-chart"
                [configuration]="displayConfiguration()"
                [transitOverlay]="chartOverlay()"
                [locksKeysOverlay]="locksKeysChartOverlay()"
                [colorConfig]="colorConfig()"
                [interactionMode]="chartInteractionMode()"
                [primaryGateAction]="displayPrimaryGateAction()"
                [contextMenuEnabled]="chartContextMenuEnabled()"
                [transientChannelHighlight]="displayChannelHighlight()"
                [channelHighlightEnabled]="channelHighlightEnabled()"
                [showHdKeynotes]="showHdKeynotes()"
                (configurationChange)="onConfigurationChange($event)"
                (gateClicked)="handleGateClicked($event)"
                (gateInfoRequested)="handleGateInfoRequested($event)"
                (channelInfoRequested)="handleChannelInfoRequested($event)"
                (centerInfoRequested)="handleCenterInfoRequested($event)"
                (gateContextMenuRequested)="handleGateContextMenuRequested($event)"
                (centerContextMenuRequested)="handleCenterContextMenuRequested($event)"
                (loadErrorChange)="handleChartLoadErrorChange($event)"
              ></hd-bodygraph-chart>
            </div>

            <div class="triple-chart-host triple-chart-host--personality">
              <h3
                [class]="'triple-chart-label triple-chart-label--' + tripleRight.labelKind"
                data-test-id="triple-chart-label-right"
              >{{ tripleRight.label }}</h3>
              <hd-bodygraph-chart
                #tripleRightChartHost
                class="triple-chart"
                [configuration]="tripleRight.configuration"
                [locksKeysOverlay]="locksKeysChartOverlay()"
                [colorConfig]="colorConfig()"
                [interactionMode]="chartInteractionMode()"
                primaryGateAction="show-info"
                [contextMenuEnabled]="chartContextMenuEnabled()"
                [channelHighlightEnabled]="channelHighlightEnabled()"
                [showHdKeynotes]="showHdKeynotes()"
                (gateClicked)="handleGateClicked($event)"
                (gateInfoRequested)="handleGateInfoRequested($event)"
                (channelInfoRequested)="handleChannelInfoRequested($event)"
                (centerInfoRequested)="handleCenterInfoRequested($event)"
                (gateContextMenuRequested)="handleGateContextMenuRequested($event)"
                (centerContextMenuRequested)="handleCenterContextMenuRequested($event)"
              ></hd-bodygraph-chart>
            </div>
          } @else if (locksKeysCompareActive()) {
            <!-- Locks & Keys periode-vergelijk (spec 2026-08-27): mandala per
                 periode naast elkaar — links de huidige, rechts de volgende —
                 met het wisselinfo-blok ertussen. In de chart-scope tonen
                 beide wielen dezelfde chart met hun eigen periode-keys;
                 algemeen blijven de wielen neutraal. Read-only (show-info). -->
            @if (locksKeysCompareInfo(); as compareInfo) {
              <div class="locks-keys-compare__side" data-test-id="locks-keys-compare-left">
                <h3 class="locks-keys-compare__label">{{ compareInfo.periods[0].label }}</h3>
                <span class="locks-keys-compare__crosses">{{ compareInfo.periods[0].crosses }}</span>
                <div class="locks-keys-compare__wheel">
                  <hd-mandala-wheel
                    [configuration]="locksKeysCompareConfiguration()"
                    [colorConfig]="colorConfig()"
                    [planetaryActivations]="locksKeysComparePlanetaryActivations()"
                    [locksKeys]="locksKeysCompareLeftViewData()"
                    [locksKeysKeynotes]="mandalaLocksKeysKeynotes()"
                    [hoverEffectsEnabled]="false"
                    primaryGateAction="show-info"
                    [contextMenuEnabled]="chartContextMenuEnabled()"
                    (gateInfoRequested)="handleGateInfoRequested($event)"
                    (locksKeysLockClicked)="handleLocksKeysLockClicked($event)"
                  ></hd-mandala-wheel>
                </div>
              </div>

              <div class="locks-keys-compare__center">
                <h3 class="locks-keys-compare__title">{{ compareInfo.title }}</h3>
                <p class="locks-keys-compare__subtitle">{{ compareInfo.subtitle }}</p>
                <div class="locks-keys-compare__periods">
                  @for (period of compareInfo.periods; track period.id) {
                    <div class="locks-keys-compare__period">
                      <span class="locks-keys-compare__period-label">{{ period.label }}</span>
                      <span class="locks-keys-compare__period-crosses">{{ period.crosses }}</span>
                      <p class="locks-keys-compare__period-keynote">{{ period.keynote }}</p>
                      @if (period.activatedCount != null) {
                        <span class="locks-keys-compare__period-count">
                          {{ period.activatedCount }}/8 {{ compareInfo.keysActiveLabel }}
                        </span>
                      }
                    </div>
                  }
                </div>
                <p class="locks-keys-compare__note">{{ compareInfo.sharedLocksNote }}</p>
              </div>

              <div class="locks-keys-compare__side" data-test-id="locks-keys-compare-right">
                <h3 class="locks-keys-compare__label">{{ compareInfo.periods[1].label }}</h3>
                <span class="locks-keys-compare__crosses">{{ compareInfo.periods[1].crosses }}</span>
                <div class="locks-keys-compare__wheel">
                  <hd-mandala-wheel
                    [configuration]="locksKeysCompareConfiguration()"
                    [colorConfig]="colorConfig()"
                    [planetaryActivations]="locksKeysComparePlanetaryActivations()"
                    [locksKeys]="locksKeysCompareRightViewData()"
                    [locksKeysKeynotes]="mandalaLocksKeysKeynotes()"
                    [hoverEffectsEnabled]="false"
                    primaryGateAction="show-info"
                    [contextMenuEnabled]="chartContextMenuEnabled()"
                    (gateInfoRequested)="handleGateInfoRequested($event)"
                    (locksKeysLockClicked)="handleLocksKeysLockClicked($event)"
                  ></hd-mandala-wheel>
                </div>
              </div>
            }
          } @else {
          @if (effectiveViewMode() !== 'chart') {
            <hd-mandala-wheel
              class="mandala-layer-host"
              [configuration]="mandalaWheelConfiguration()"
              [colorConfig]="colorConfig()"
              [planetaryActivations]="mandalaWheelPlanetaryActivations()"
              [singleInfoRing]="effectiveSingleInfoRing()"
              [geometry]="effectiveMandalaGeometry()"
              [moonTransit]="moonTransitViewData()"
              [justNowTransit]="justNowTransitViewData()"
              [locksKeys]="locksKeysViewData()"
              [locksKeysKeynotes]="mandalaLocksKeysKeynotes()"
              [patterns]="mandalaPatternsViewData()"
              (locksKeysLockClicked)="handleLocksKeysLockClicked($event)"
              [hoverEffectsEnabled]="!moonTransitMode()"
              [moonTransitHighlightedKeys]="moonTransitHighlightedChannelKeys()"
              [justNowTransitHighlightedKeys]="justNowTransitHighlightedChannelKeys()"
              (moonTransitGateHovered)="handleMoonTransitGateHovered($event)"
              (moonTransitConnectorHovered)="handleMoonTransitFormationHovered($event)"
              (moonTransitConnectorClicked)="handleMoonTransitFormationClicked($event)"
              (justNowTransitGateHovered)="handleJustNowTransitGateHovered($event)"
              (justNowTransitConnectorHovered)="handleJustNowTransitFormationHovered($event)"
              (justNowTransitConnectorClicked)="handleJustNowTransitFormationClicked($event)"
              [showZodiacRing]="showMandalaZodiacRing()"
              [showQuarterRing]="showMandalaQuarterRing()"
              [showIchingRing]="showMandalaIchingRing()"
              [showGodheadRing]="showMandalaGodheadRing()"
              [showSliceCenterFill]="mandalaSliceCenterFade()"
              [gateGlyphs]="mandalaWheelGateGlyphs()"
              [quarterColorVariant]="mandalaQuarterColorVariant()"
              [zodiacRingVariant]="mandalaZodiacRingVariant()"
              [quarterTexts]="mandalaQuarterTexts()"
              [zodiacSignNames]="mandalaZodiacNames()"
              [seasonTexts]="mandalaSeasonTexts()"
              [interactionMode]="chartInteractionMode()"
              [primaryGateAction]="displayPrimaryGateAction()"
              [contextMenuEnabled]="chartContextMenuEnabled()"
              (gateClicked)="handleGateClicked($event)"
              (configurationChange)="onConfigurationChange($event)"
              (gateInfoRequested)="handleGateInfoRequested($event)"
              (gateContextMenuRequested)="handleGateContextMenuRequested($event)"
            ></hd-mandala-wheel>
          }
          @if (effectiveViewMode() !== 'mandala') {
            <hd-bodygraph-chart
              #bodygraphChart
              class="bodygraph-layer-host"
              [configuration]="moonTransitChartConfiguration()"
              [transitOverlay]="chartOverlay()"
              [showMonopoleAndCrystals]="showMonopoleAndCrystals()"
              [locksKeysOverlay]="locksKeysChartOverlay()"
              [colorConfig]="colorConfig()"
              [interactionMode]="chartInteractionMode()"
              [primaryGateAction]="displayPrimaryGateAction()"
              [contextMenuEnabled]="chartContextMenuEnabled()"
              [revealedGates]="displayRevealedGates()"
              [errorFlashGates]="errorFlashGates()"
              [correctFlashGates]="correctFlashGates()"
              [selectionHighlightGates]="selectionHighlightGates()"
              [transientChannelHighlight]="displayChannelHighlight()"
              [channelHighlightEnabled]="channelHighlightEnabled()"
              [showHdKeynotes]="showHdKeynotes()"
              [showCenterCheatSheet]="showCenterCheatSheet() && effectiveViewMode() === 'chart'"
              (configurationChange)="onConfigurationChange($event)"
              (revealedGatesChange)="handleRevealedGatesChange($event)"
              (gateClicked)="handleGateClicked($event)"
              (gateHovered)="handleTransitChartGateHovered($event)"
              (gateInfoRequested)="handleGateInfoRequested($event)"
              (channelInfoRequested)="handleChannelInfoRequested($event)"
              (centerInfoRequested)="handleCenterInfoRequested($event)"
              (monopoleInfoRequested)="handleMonopoleInfoRequested($event)"
              (gateContextMenuRequested)="handleGateContextMenuRequested($event)"
              (centerContextMenuRequested)="handleCenterContextMenuRequested($event)"
              (loadErrorChange)="handleChartLoadErrorChange($event)"
            >
              @if (gateBlockLayerVisible()) {
                <hd-gate-block-layer
                  [activations]="displayPlanetaryActivations()"
                  [renderState]="displayRenderState()"
                  [gateAnchors]="bodygraphChart.gateAnchors()"
                  [pins]="gateBlockPins()"
                  [moveToolActive]="moveToolActive()"
                  (pinCommitted)="handleGateBlockPinCommitted($event)"
                  (pinRemoved)="handleGateBlockPinRemoved($event)"
                ></hd-gate-block-layer>
              }
            </hd-bodygraph-chart>
          }
          @if (moonTransitViewData(); as moonTransit) {
            <hd-moon-transit-card-layer
              [formations]="moonTransit.formations"
              [geometry]="effectiveMandalaGeometry()"
              [todayLongitude]="moonTransit.todayLongitude"
              [highlightedChannelKeys]="moonTransitHighlightedChannelKeys()"
              [pins]="moonTransitPins()"
              [moveToolActive]="moveToolActive()"
              (formationClicked)="handleMoonTransitFormationClicked($event)"
              (formationHovered)="handleMoonTransitFormationHovered($event)"
              (pinCommitted)="handleMoonTransitPinCommitted($event)"
              (pinRemoved)="handleMoonTransitPinRemoved($event)"
            ></hd-moon-transit-card-layer>
          }
          @if (justNowTransitMandalaVisible()) {
            @if (justNowTransitViewData(); as justNowTransit) {
              <hd-just-now-transit-card-layer
                [formations]="justNowTransit.formations"
                [geometry]="effectiveMandalaGeometry()"
                [highlightedChannelKeys]="justNowTransitHighlightedChannelKeys()"
                [pins]="justNowTransitPins()"
                [moveToolActive]="moveToolActive()"
                (formationClicked)="handleJustNowTransitFormationClicked($event)"
                (formationHovered)="handleJustNowTransitFormationHovered($event)"
                (pinCommitted)="handleJustNowTransitPinCommitted($event)"
                (pinRemoved)="handleJustNowTransitPinRemoved($event)"
              ></hd-just-now-transit-card-layer>
            }
          }
          }
        </div>
      </e-card2>

      @if (chartLoadError()) {
        <div class="chart-load-error-message">
          De chart kan momenteel door een onverwacht probleem niet geladen worden. Gelieve later nog eens te proberen.
        </div>
      }

      @if (mandalaHiddenForSpace() && !chartLoadError()) {
        <div class="mandala-space-hidden-message">{{ mandalaSpaceHiddenText() }}</div>
      }

      @if (!chartLoadError() && !gameActive() && effectiveShowPlanetGrid() && (hasPlanetaryActivations() || justNowTransitVisualsActive())) {
        @if (activeCycleInfo() || activeCompositeInfo()) {
          <!-- Cycle/composite chart: tweede kant D+P gecombineerd, titel in de
               cycle-kleur; fixing t.o.v. de top-level chart. -->
          <hd-just-now-base-planet-grid
            class="personality-planet-grid"
            #mandalaRightOverlay
            [activations]="cycleMomentGridActivations()"
            [transitActivations]="allPlanetaryActivations()"
            [sideMode]="'full'"
            [lineData]="justNowTransitLineData"
            [planetName]="justNowTransitPlanetName"
            [labels]="justNowBasePlanetGridLabels()"
            [titleAccentColor]="cycleTitleColor"
            [chartLabel]="compositeChart2Label()"
            [designChiron]="showChiron() ? cycleMomentDesignChiron() : null"
            [personalityChiron]="showChiron() ? cycleMomentPersonalityChiron() : null"
            [contextMenuEnabled]="chartContextMenuEnabled()"
            (planetActivationClicked)="handlePlanetActivationClicked($event)"
            (planetBlockContextMenuRequested)="handlePlanetBlockContextMenuRequested($event)"
          />
        } @else if (justNowTransitVisualsActive()) {
          <hd-just-now-transit-planet-grid
            class="personality-planet-grid"
            #mandalaRightOverlay
            [activations]="justNowTransitActivations()"
            [chiron]="justNowTransitChiron()"
            [lineData]="justNowTransitLineData"
            [labels]="justNowTransitPlanetGridLabels()"
            [contextMenuEnabled]="chartContextMenuEnabled()"
            (planetActivationClicked)="handlePlanetActivationClicked($event)"
            (planetBlockContextMenuRequested)="handlePlanetBlockContextMenuRequested($event)"
          />
        } @else if (effectiveSimplePlanetGrid()) {
          <hd-simple-planet-grid
            class="personality-planet-grid"
            #mandalaRightOverlay
            [activations]="personalityActivations()"
            side="personality"
            [showGrid]="effectiveSideMode() !== 'design'"
            [chiron]="showChiron() ? personalityChiron() : null"
            [showHdKeynotes]="showHdKeynotes()"
            [contextMenuEnabled]="chartContextMenuEnabled()"
            [colorConfig]="planetGridColorConfig()"
            [showTransformationArrows]="effectivePlanetGridDensity() === 'normal'"
            (phsBlockClicked)="handlePhsBlockClicked($event)"
            (chironClicked)="handleChironClicked($event)"
            (planetActivationClicked)="handlePlanetActivationClicked($event)"
            (planetBlockContextMenuRequested)="handlePlanetBlockContextMenuRequested($event)"
          ></hd-simple-planet-grid>
        } @else {
          <hd-planet-grid
            class="personality-planet-grid"
            #mandalaRightOverlay
            [activations]="personalityActivations()"
            side="personality"
            [density]="effectivePlanetGridDensity()"
            [renderState]="displayRenderState()"
            [colorConfig]="planetGridColorConfig()"
            [resonanceMode]="effectiveAdvancedLpsGrid()"
            [visualizationMode]="planetGridVisualizationMode()"
            [showGeneKeys]="showGeneKeys()"
            [showHdKeynotes]="showHdKeynotes()"
            [showSideStats]="effectiveShowPlanetSideStats()"
            [showGrid]="effectiveSideMode() !== 'design'"
            [oppositeActivations]="designActivations()"
            [allActivations]="allPlanetaryActivations()"
            [statsSide]="effectiveSideMode() === 'full' ? null : effectiveSideMode()"
            [statsOverallRenderState]="renderState()"
            [contextMenuEnabled]="chartContextMenuEnabled()"
            [astroPoints]="showAstroPositions() ? personalityAstroPoints() : []"
            [astroChiron]="showAstroPositions() && showChiron() ? personalityChironPosition() : null"
            (astroPointClicked)="handleAstroPointClicked($event)"
            (planetActivationClicked)="handlePlanetActivationClicked($event)"
            (phsBlockClicked)="handlePhsBlockClicked($event)"
            (planetBlockContextMenuRequested)="handlePlanetBlockContextMenuRequested($event)"
          ></hd-planet-grid>
        }
      }

      <!-- Maan-transit legendes in de onderhoeken van de chart-area:
           kanaaltypes linksonder (onder de design-grid), symbolen rechtsonder
           (onder de personality-grid). Informatief → inert voor de muis. -->
      @if (moonTransitMode() && !chartLoadError()) {
        <hd-moon-transit-legend section="channels" class="moon-transit-legend-left"></hd-moon-transit-legend>
        <hd-moon-transit-legend section="symbols" class="moon-transit-legend-right"></hd-moon-transit-legend>
      }

      <!-- Annotatie-overlay: spant de hele chart-stack (chart + planeetgrids),
           ligt qua z-index boven de grids zodat er ook over de grids getekend
           kan worden, en is inert (pointer-events:none) tot een tool actief is. -->
      <hd-chart-annotation-layer [buttonSize]="shortcutButtonSize()"></hd-chart-annotation-layer>
    </div>
  </div>

  @if (!configPanelCollapsed()) {
    <!-- Sleeplijn (desktop): maakt het paneel erna breder, nooit smaller dan de standaard.
         Enkel zichtbaar als de inhoud breder is dan het paneel of het paneel al breder staat;
         past de inhoud niet, dan zet het knopje onder de greep het paneel op maat ervan. -->
    <e-resize-handle
      class="config-panel-resize-handle"
      data-test-id="config-panel-resize"
      [available]="configPanelResizable()"
      [contentShortfall]="configPanelContentShortfall()"
      [minSize]="configPanelMinWidth"
      [(size)]="configPanelWidth"
      (sizeCommitted)="handleConfigPanelResized($event)"
    ></e-resize-handle>
  }

  <!-- data-dock-bounds: zichtbare rand van de dock (zwevende transits landen ernaast). -->
  <e-card2 class="config-panel right-dock-area" [class.is-collapsed]="configPanelCollapsed()" padding="4" data-dock-bounds>
    <!-- Inklappen: kolom → smalle rail; het dock-area blijft gemount (enkel
         verborgen) zodat gedockte panelen hun staat behouden. -->
    <button
      type="button"
      class="config-panel-collapse-toggle"
      [attr.aria-label]="'Configuratiepaneel inklappen'"
      [attr.title]="'Configuratiepaneel inklappen'"
      data-test-id="config-panel-collapse"
      (click)="toggleConfigPanelCollapsed()"
    ><i eIcon icon="chevron-right" family="solid"></i></button>
    <dock-area [zones]="['small', 'full']" [sideBySideFixedTabs]="false" [collapsed]="configPanelCollapsed()">
      <ng-template [dockFixedTab]="dockTabLabels().basic" dockFixedTabId="basic">
        @if (activeCompositeInfo(); as composite) {
          <!-- Composite: kies wiens basis-gegevens getoond worden (1 = blauw, 2 = groen). -->
          <div class="basic-chart-picker" role="tablist">
            <button type="button" class="basic-chart-picker__option"
                    [class.is-active]="basicCompositeSide() === 1"
                    [style.--picker-color]="compositeChart1Color"
                    [attr.aria-selected]="basicCompositeSide() === 1"
                    (click)="basicCompositeSide.set(1)">
              {{ composite.source.name }}
            </button>
            <button type="button" class="basic-chart-picker__option"
                    [class.is-active]="basicCompositeSide() === 2"
                    [style.--picker-color]="cycleTitleColor"
                    [attr.aria-selected]="basicCompositeSide() === 2"
                    (click)="basicCompositeSide.set(2)">
              {{ composite.partner.name }}
            </button>
          </div>
        }
        <hd-basic-properties
          [configuration]="basicConfiguration()"
          [planetaryActivations]="basicPlanetaryActivations()"
          [advancedBridgeCalculation]="advancedBridgeCalculation()"
          [bridgeGateStyle]="bridgeGateStyle()"
          [environmentMatchesEnabled]="!activePreset()?.cycle && !activePreset()?.composite"
          [matchScope]="chartMatchScope()"
          [savedChartId]="savedChartId()"
          [chironPositions]="basicChironPositions()"
          [chartLinked]="basicPanelChartLink()"
          [viewMode]="panelViewMode()"
          (gateInfoRequested)="handleGateInfoRequested($event)"
          (channelInfoRequested)="handleChannelInfoRequested($event)"
          (chartOpenRequested)="loadChartFromLibrary($event, true)"
          (lifeCrossInfoRequested)="handleLifeCrossInfoRequested()"
          (profileInfoRequested)="handleProfileInfoRequested()"
          (incarnationCrossInfoRequested)="handleIncarnationCrossInfoRequested()"
          (basicsInfoRequested)="handleBasicsInfoRequested()"
          (typeInfoRequested)="handleTypeInfoRequested($event)"
          (authorityInfoRequested)="handleAuthorityInfoRequested()"
          (definitionInfoRequested)="handleDefinitionInfoRequested()"
          (conditioningInfoRequested)="handleConditioningInfoRequested()"
          (centerInfoRequested)="handleCenterInfoRequested($event)"
          (chironClicked)="handleChironClicked($event)"
        ></hd-basic-properties>
      </ng-template>

      <ng-template [dockFixedTab]="dockTabLabels().advanced" dockFixedTabId="advanced">
        <hd-advanced-properties
          [birthData]="activePreset()?.birthData ?? null"
          [savedChartId]="savedChartId()"
          [chartName]="activePreset()?.name ?? ''"
          [chartType]="activeChartType()"
          [preset]="activePreset()"
          [matchScope]="chartMatchScope()"
          [bridgeGateStyle]="bridgeGateStyle()"
          [viewMode]="panelViewMode()"
          (chartOpenRequested)="loadChartFromLibrary($event, true)"
          (chartOpenWithNotesRequested)="handleChartOpenWithNotes($event)"
          (timelineRequested)="handleTimelineRequested($event)"
          (mindLogRequested)="handleMindLogRequested($event)"
          (cycleCalculateRequested)="handleCycleCalculateRequested($event)"
          (cycleJustNowTransitRequested)="handleCycleJustNowTransitRequested()"
          (cycleRecalculateRequested)="handleCycleRecalculateRequested()"
          (cycleLifeCrossInfoRequested)="handleCycleLifeCrossInfoRequested($event)"
          (cycleChironInfoRequested)="handleCycleChironInfoRequested($event)"
          (cycleDefinitionInfoRequested)="handleCycleDefinitionInfoRequested($event)"
          (compositeCalculateRequested)="handleCompositeCalculateRequested($event)"
          (compositeThemeInfoRequested)="handleCompositeThemeInfoRequested($event)"
          (relationInfoRequested)="handleRelationInfoRequested($event)"
          (gateInfoRequested)="handleGateInfoRequested($event)"
          (channelInfoRequested)="handleChannelInfoRequested($event)"
          (centerInfoRequested)="handleCenterInfoRequested($event)"
          (locksKeysRequested)="handleLocksKeysRequestedFromAdvanced()"
          (birthWindowRequested)="handleBirthWindowRequestedFromAdvanced()"
          (conditioningInfoRequested)="handleConditioningInfoRequested()"
        ></hd-advanced-properties>
      </ng-template>

      <ng-template [dockFixedTab]="dockTabLabels().editor" dockFixedTabId="editor">
        <div class="editor-configurators">
          <hd-bodygraph-configurator
            [configuration]="configuration()"
            [layoutConfig]="channelsConfiguratorLayout"
            [colorConfig]="colorConfig()"
            [circuitFreezeModeAvailable]="circuitFreezeModeAvailable()"
            [circuitFreezeModeDisabledReason]="circuitFreezeModeDisabledReason()"
            (configurationChange)="onConfigurationChange($event)"
            (fillAllRequested)="handleFillAllRequested()"
            (clearAllRequested)="handleShortcutResetRequested()"
          ></hd-bodygraph-configurator>

          <hd-bodygraph-configurator
            [configuration]="configuration()"
            [layoutConfig]="gatesConfiguratorLayout"
            [colorConfig]="colorConfig()"
            [circuitFreezeModeAvailable]="circuitFreezeModeAvailable()"
            [circuitFreezeModeDisabledReason]="circuitFreezeModeDisabledReason()"
            [mandalaPatternOptions]="mandalaPatternOptions()"
            (mandalaPatternOptionsChange)="mandalaPatternOptions.set($event)"
            [showMonopoleAndCrystals]="showMonopoleAndCrystals()"
            (showMonopoleAndCrystalsChange)="showMonopoleAndCrystals.set($event)"
            (configurationChange)="onConfigurationChange($event)"
          ></hd-bodygraph-configurator>
        </div>
      </ng-template>

      <!-- Notities (spec notable moments §6): chart-notities + per link de link-notities. -->
      <ng-template [dockFixedTab]="dockTabLabels().notes" dockFixedTabId="notes">
        @if (notesFloating()) {
          <!-- Notities losgemaakt: ze staan in een zwevend venster. -->
          <div class="notes-floating-placeholder" data-test-id="notes-floating-placeholder">
            <i class="fas fa-arrow-up-right-from-square notes-floating-placeholder__icon" aria-hidden="true"></i>
            <span>{{ notesPlaceholderText().placeholder }}</span>
            <button eBtn color="highlight" size="sm" icon="arrow-down-left-and-arrow-up-right-to-center"
                    (click)="handleNotesRedockRequested()">{{ notesPlaceholderText().redock }}</button>
          </div>
        } @else {
          <hd-notes-panel
            [savedChartId]="savedChartId()"
            [chartName]="activePreset()?.name ?? ''"
            [undockable]="true"
            (chartOpenRequested)="loadChartFromLibrary($event, true)"
            (undockRequested)="handleNotesUndockRequested()"
          ></hd-notes-panel>
        }
      </ng-template>
    </dock-area>
  </e-card2>

  @if (configPanelCollapsed()) {
    <!-- Smalle rail op de plek van de ingeklapte kolom: één klik klapt uit. -->
    <button
      type="button"
      class="config-panel-rail"
      [attr.aria-label]="'Configuratiepaneel uitklappen'"
      [attr.title]="'Configuratiepaneel uitklappen'"
      data-test-id="config-panel-expand"
      (click)="toggleConfigPanelCollapsed()"
    ><i eIcon icon="chevron-left" family="solid"></i></button>
  }
  </div>
</section>

<!-- Het settings-paneel is verhuisd naar de HD-app-shell (hd-app-shell.component),
     zodat het overal binnen de HD-app te openen is en aan de centrale
     HdChartSettingsStore hangt. De chart-pagina opent het via store.panelOpen
     (alias settingsPanelOpen) en registreert de print-actie in de store. -->

<hd-chart-game-dialog
  [(open)]="gameDialogOpen"
  [gameMode]="gameMode()"
  [gameActive]="gameActive()"
  [selectedGameId]="selectedGameId()"
  [selectedGameVariantId]="selectedGameVariantId()"
  [gateRangeSortEnabled]="gateRangeSortEnabled()"
  [gateRangeStart]="gateRangeStart()"
  [gateRangeEnd]="gateRangeEnd()"
  [drawChartTargetId]="selectedDrawChartTargetId()"
  (gameModeToggled)="toggleGameMode()"
  (gameSelectionChange)="handlePanelGameSelectionChange($event)"
  (gameVariantChange)="selectedGameVariantId.set($event)"
  (gateRangeSortToggled)="gateRangeSortEnabled.set(!gateRangeSortEnabled())"
  (gateRangeStartChange)="gateRangeStart.set($event)"
  (gateRangeEndChange)="gateRangeEnd.set($event)"
  (drawChartTargetChange)="selectedDrawChartTargetId.set($event)"
  (playClicked)="handlePanelPlayClicked()"
  (stopRequested)="handleShortcutStopRequested()"
></hd-chart-game-dialog>

<hd-chart-create-dialog [(open)]="createDialogOpen" (calculated)="handleNewChartCalculated($event)"></hd-chart-create-dialog>
<hd-chart-manager-dialog
  [(open)]="managerDialogOpen"
  (loadChartRequested)="handleManagerLoadRequested($event)"
  (calculatedChartRequested)="handleNewChartCalculated($event)"
  (chartsDeleted)="handleChartsDeleted($event)"
  (chartUpdated)="handleChartUpdated($event)"
  (gameRequested)="handleManagerGameRequested()"
  (justNowRequested)="handleManagerJustNowRequested()"
  (justNowFullRequested)="handleManagerJustNowFullRequested()"
  (raveNewYearRequested)="handleRaveNewYearRequested($event)"
  (emptyChartRequested)="handleManagerEmptyChartRequested()"
  (timelineRequested)="handleTimelineRequested($event)"
></hd-chart-manager-dialog>

<hd-chart-rename-dialog [(target)]="renameDialogTarget" (confirmed)="handleChartRenamed($event)"></hd-chart-rename-dialog>
<hd-chart-print-dialog [(target)]="printDialogTarget" (confirmed)="handlePrintConfirmed($event)"></hd-chart-print-dialog>

<!-- Chart delen via link (spec 2026-10-20-chart-share): zelfde dialoog als in de chart manager. -->
<hd-chart-share-dialog [(target)]="shareDialogTarget" (shareChanged)="handleShareChanged($event)"></hd-chart-share-dialog>

<hd-moment-save-dialog [(target)]="momentSaveDialogTarget" (confirmed)="handleMomentSaveConfirmed($event)"></hd-moment-save-dialog>

<hd-birth-window-confirm-dialog [(target)]="birthWindowConfirmTarget" (confirmed)="handleBirthWindowConfirmed()"></hd-birth-window-confirm-dialog>
